import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import logo from "../../assets/digitalparag/DigirtalParag.png";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { api_url } from "../../helpers/apiHelpers";

const AdminLogin = () => {
    const [formData, setFormData] = useState({
        email: "",
        password: "",
    });
    const [showPassword, setShowPassword] = useState(false);

    const navigate = useNavigate(); // to redirect users

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleSubmit = async () => {
        try {
            const response = await fetch(`${api_url}/api/auth/admin-signin`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            });

            const data = await response.json();

            if (data.status === 201) {
                toast.success("Logged in successfully!");
                localStorage.setItem("adminId", data.admin._id);
                localStorage.setItem("adminName", data.admin.name);
                localStorage.setItem("adminEmail", data.admin.email);
                setTimeout(() => {
                    navigate("/admin/admin_dashboard");
                }, 1000)
            } else {
                toast.error(data.message); // handle error
            }
        } catch (err) {
            toast.error("Something went wrong!");
        }
    };

    return (
        <div className="mt-5">
            <div className="container py-5">

                <div
                    className="w-full px-6 py-4 m-auto md:px-8 lg:w-1/3"
                    style={{ backgroundColor: "#a3c8e8" }}
                >
                    <div className="flex justify-center mx-auto">
                        <img className="h-20 w-30 mr-3" src={logo} alt="Logo" />
                    </div>
                    <h4 className="text-2xl fw-bold text-center text-dark  ">Admin Sing In</h4>
                    <form>
                        <div className="mt-3 text-left">
                            <label
                                className="block mb-2 text-base font-medium text-dark  "
                                htmlFor="email"
                            >
                                Email Address
                            </label>
                            <input
                                id="email"
                                name="email"
                                className="block w-full px-4 py-2 text-gray-700 bg-white border rounded-lg   dark:border-gray-600 focus:border-blue-400 focus:ring-opacity-40 dark:focus:border-blue-300 focus:outline-none focus:ring focus:ring-blue-300"
                                type="email"
                                value={formData.email}
                                placeholder="Enter Email"
                                onChange={handleChange}
                            />
                        </div>

                        <div className="mt-3">
                            <div className="flex justify-between">
                                <label
                                    className="block mb-2 text-base font-medium text-dark  "
                                    htmlFor="password"
                                >
                                    Password
                                </label>
                            </div>
                            <div className="relative">
                                <input
                                    placeholder="Enter Password"
                                    id="password"
                                    name="password"
                                    className="block w-full px-4 py-2 text-gray-700 bg-white border rounded-lg  dark:border-gray-600 focus:border-blue-400 focus:ring-opacity-40 dark:focus:border-blue-300 focus:outline-none focus:ring focus:ring-blue-300"
                                    type={showPassword ? "text" : "password"} // Toggle between text and password
                                    value={formData.password}
                                    onChange={handleChange}
                                />
                                <button
                                    type="button"
                                    className="absolute right-2 top-2 text-white  "
                                    onClick={togglePasswordVisibility}
                                >
                                    {showPassword ? (
                                        <AiFillEyeInvisible size={20} />
                                    ) : (
                                        <AiFillEye size={20} />
                                    )}
                                </button>
                            </div>
                        </div>

                        <div className="mt-3 text-center">
                            <button
                                type="button"
                                onClick={() => handleSubmit()}
                                className="w-1/2 px-6 py-2 text-base font-medium tracking-wide text-white capitalize transition-colors duration-300 transform bg-gray-800 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring focus:ring-gray-300 focus:ring-opacity-50"
                            >
                                Sign In
                            </button>
                        </div>
                    </form>

                </div>
            </div>
            <ToastContainer />
        </div>
    );
};

export default AdminLogin
